import { render, staticRenderFns } from "./ECG.vue?vue&type=template&id=9e849f50&"
import script from "./ECG.vue?vue&type=script&lang=ts&"
export * from "./ECG.vue?vue&type=script&lang=ts&"
import style0 from "./ECG.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports